<template>
  <div class="home-dialog">
    <month-ticket-dialog
      @close="closeDialog"
      ref="MonthTicketDialog">
    </month-ticket-dialog>
    <welfare-activity-dialog
      ref="WelfareActivityDialog"
      @close="closeDialog"
    >
    </welfare-activity-dialog>
    <confirm-dialog
      title="每日签到"
      message='每日签到领积分，可以免费兑换票哦'
      @confirm="confirmDialogBtn"
      :type="1"
      ref="ConfirmDialog">
    </confirm-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import MonthTicketDialog from '@/components/dialog/MonthTicketDialog' // 月票弹框
import WelfareActivityDialog from '@/components/dialog/vip-home/WelfareActivity' // 召回活动弹框
import ConfirmDialog from '@/components/dialog/ConfirmDialog' // 签到弹框
import { wxNavigateTo } from '@/utils/WeChatUtil'
export default {
  props: {},
  data() {
    return {
      dialogRef: ['WelfareActivityDialog', 'MonthTicketDialog', 'ConfirmDialog'],
    }
  },
  computed: {
    ...mapState({
      dialog_index: 'vip_home_dialog_index'
    })
  },
  watch: {
    dialog_index() {
      this.init()
    },
  },
  components: {
    MonthTicketDialog,
    WelfareActivityDialog,
    ConfirmDialog
  },
  created() {},
  mounted() {},
  methods: {
    ...mapMutations({
      updateDialogIndex: 'updateStateData'
    }),
    init() {
      const { dialog_index, dialogRef } = this
      this.$refs[dialogRef[dialog_index]].init()
    },
    closeDialog() {
      let { dialog_index } = this
      dialog_index++
      this.updateDialogIndex({
        key: 'vip_home_dialog_index',
        value: dialog_index
      })
    },
    /**
     *
     *
     *
     * 确认弹框确认事件
    */
    confirmDialogBtn () {
      if (this.isWechart) {
          wxNavigateTo('../activity/sign/sign')
      }
    },
  }
}
</script>

<style scoped lang="scss"></style>
